import React from 'react';
import '../App.css';
import { useTranslation } from 'react-i18next';

function InvestmentBasics() {
  const { t } = useTranslation(); // 與 Home.js 相同，用 useTranslation()

  return (
    <div className="article-container">
      <h1>{t('investmentBasics.title')}</h1>

      <h2>{t('investmentBasics.introductionHeading')}</h2>
      <p>{t('investmentBasics.introductionParagraph1')}</p>
      <p>{t('investmentBasics.introductionParagraph2')}</p>

      <h2>{t('investmentBasics.howToUseHeading')}</h2>
      <p>{t('investmentBasics.howToUseParagraph1')}</p>
      <p>{t('investmentBasics.howToUseParagraph2')}</p>

      <h2>{t('investmentBasics.naturalSelectionHeading')}</h2>
      <p>{t('investmentBasics.naturalSelectionParagraph')}</p>
    </div>
  );
}

export default InvestmentBasics;
